export const TappayCreditCardFrameConfig = {
  CARD_NUMBER_FRAME: 'cc-number',
  EXPIRATION_DATE_FRAME: 'cc-exp',
  CCV_FRAME: 'cc-ccv',
  CARDHOLDER_NAME_FRAME: 'name_en',
  CARDHOLDER_EMAIL_FRAME: 'email',
  CARDHOLDER_PHONE_COUNTRY_FRAME: 'country_code',
  CARDHOLDER_PHONE_NUMBER_FRAME: 'number',
}

export const cardFields = {
  number: {
    element: `#${TappayCreditCardFrameConfig.CARD_NUMBER_FRAME}`,
    placeholder: '**** **** **** ****',
  },
  expirationDate: {
    element: `#${TappayCreditCardFrameConfig.EXPIRATION_DATE_FRAME}`,
    placeholder: 'MM/YY',
  },
  ccv: {
    element: `#${TappayCreditCardFrameConfig.CCV_FRAME}`,
    placeholder: 'CCV',
  },
}
export const cardholderFields = {
  name_en: {
    element: `#${TappayCreditCardFrameConfig.CARDHOLDER_NAME_FRAME}`,
    placeholder: 'e.g., MEI HUA LIN',
  },
  email: {
    element: `#${TappayCreditCardFrameConfig.CARDHOLDER_EMAIL_FRAME}`,
    placeholder: 'name@example.com',
  },
  phone: {
    country_code: {
      element: `#${TappayCreditCardFrameConfig.CARDHOLDER_PHONE_COUNTRY_FRAME}`,
      placeholder: '886',
    },
    number: {
      element: `#${TappayCreditCardFrameConfig.CARDHOLDER_PHONE_NUMBER_FRAME}`,
      placeholder: '912345678',
    },
  },
}
